import {
  AttendanceEditTimesheetRequest,
  AttendanceEditTimesheetRequestRequestTypeEnum,
} from 'generated/resources/graphql'

class EditTimesheetRequestUtils {
  static isCreateShift(request: Pick<AttendanceEditTimesheetRequest, 'requestType'>) {
    return request.requestType && request.requestType === 'create_shift'
  }

  static isUpdateShift(request: Pick<AttendanceEditTimesheetRequest, 'requestType'>) {
    return request.requestType && request.requestType === 'update_shift'
  }

  static isDeleteShift(request: Pick<AttendanceEditTimesheetRequest, 'requestType'>) {
    return request.requestType && request.requestType === 'delete_shift'
  }

  static isPending(request: Pick<AttendanceEditTimesheetRequest, 'approved'>) {
    return request.approved == null
  }

  // Only "create_shift" have the date field, since update ones have the attendance_shift_id
  // also, both rejected and approved requests have the key "approved", while the pending ones don't
  static getPendingCreateShiftRequests<
    T extends Pick<AttendanceEditTimesheetRequest, 'approved' | 'requestType'>
  >(editTimesheetRequests: T[]): T[] {
    const createShiftType: AttendanceEditTimesheetRequestRequestTypeEnum = 'create_shift'

    return editTimesheetRequests.filter(
      (r) => r.approved === null && r.requestType === createShiftType
    )
  }
}

export default EditTimesheetRequestUtils
